import { Lock, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import PlanPicker from "./PlanPicker";
import T from "../theme/colors";

/**
 * Phase 36da.99.gj — shown in place of the whole app when the global
 * subscription is LOCKED.  The user stays logged in so an owner/admin can
 * pick a plan and pay; non-admins see a contact-admin note (via PlanPicker).
 */
export default function PayWall() {
    const { subscription: sub, logout } = useAuth();
    const canPay = !!sub?.canPay;

    return (
        <div style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            background: "var(--bg-app)", padding: 24, fontFamily: "var(--font-ui)",
        }}>
            <div style={{
                width: "100%", maxWidth: 520, background: "var(--bg-card)", borderRadius: 16,
                border: `1px solid var(--border)`, boxShadow: "var(--shadow-xl)", padding: "36px 32px", textAlign: "center",
            }}>
                <div style={{
                    width: 60, height: 60, borderRadius: "50%", margin: "0 auto 16px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    background: "var(--danger-bg)", color: "var(--danger)",
                }}>
                    <Lock size={28} />
                </div>

                <h1 style={{ margin: "0 0 8px", fontSize: 25, fontWeight: 700, color: "var(--text-0)" }}>
                    Subscription expired
                </h1>
                <p style={{ margin: "0 0 12px", fontSize: 17, lineHeight: 1.55, color: "var(--text-1)" }}>
                    {sub?.message || "Your access has been paused. Please renew to continue."}
                </p>
                {sub?.paidUntil && (
                    <p style={{ margin: "0 0 22px", fontSize: 15, color: "var(--text-2)" }}>
                        Expired on {String(sub.paidUntil)}
                    </p>
                )}

                <div style={{ textAlign: "left" }}>
                    <PlanPicker monthlyPaise={sub?.amountPaise} canPay={canPay} />
                </div>

                <button onClick={logout} style={{
                    marginTop: 20, background: "none", border: "none", cursor: "pointer",
                    color: "var(--text-2)", fontSize: 15, display: "inline-flex", alignItems: "center", gap: 6,
                    fontFamily: "var(--font-ui)",
                }}>
                    <LogOut size={14} /> Log out
                </button>
            </div>
        </div>
    );
}